<mat-card class="comment">
  <mat-card-header>
    <mat-card-title>{{comment.commentator_obj.first_name}} {{comment.commentator_obj.last_name}}
      <span><mat-icon *ngIf="individu.uid === comment.commentator" (click)="deleteComment()">delete</mat-icon></span>
      <span><mat-icon *ngIf="individu.uid === comment.commentator" (click)="openEditComment()">create</mat-icon></span>
      <span><mat-icon *ngIf="comment.type === commentTypeEnum.private">lock</mat-icon></span>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <pre>{{comment.content}}</pre>
  </mat-card-content>
  <mat-card-footer><span>{{comment.dt_created | date: 'dd/MM/yyyy à HH:mm '}}</span></mat-card-footer>
</mat-card>
